import React from "react";
import { usePaystack } from "../../hooks/usePaystack";

const PaystackCheckoutButton = ({
    amount,
    currency = "ZAR",
    referencePrefix = "payment",
    metadata,
    customFields,
    contextData,
    onSuccess,
    onError,
    className = "",
    disabled = false,
    children = "Pay with Paystack",
}) => {
    const { initializePayment, loading } = usePaystack();

    const handleClick = () => {
        if (disabled || loading) return;

        initializePayment({
            amount,
            currency,
            referencePrefix,
            metadata,
            customFields,
            contextData,
            onSuccess,
            onError,
        });
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={disabled || loading}
            className={`${className} ${disabled || loading ? "opacity-70 cursor-not-allowed" : ""}`}
        >
            {loading ? "Processing..." : children}
        </button>
    );
};

export default PaystackCheckoutButton;

